import LegalPage from "@/pages/LegalPage";

// Straightforward starting-point privacy policy. Written in plain English
// so a customer of a plumbing / HVAC / automotive shop can read it and
// understand what's actually happening with their data. The operator
// should still have counsel review this before large-scale launch.
export default function PrivacyPolicy() {
  return (
    <LegalPage
      title="Privacy Policy"
      lastUpdated="July 21, 2026"
      testId="privacy-policy-page"
    >
      <p>
        Your Monday Brief ("we", "us", "our") builds a weekly business advisory
        service for local trade and service businesses. This policy describes
        what we collect, why we collect it, and the choices you have. It applies
        to <a href="https://yourmondaybrief.com">yourmondaybrief.com</a> and any
        emails we send you from <em>briefs@bullsharkbuilds.com</em>.
      </p>

      <h2>1. Information we collect</h2>
      <p>When you sign up or complete onboarding, we collect:</p>
      <ul>
        <li>Your business name, address, service area, and trade category.</li>
        <li>Your email address, phone number, and website URL if you provide them.</li>
        <li>Information you tell us about the areas you'd like help with.</li>
        <li>Publicly available information about your business from sources like Google Business Profile.</li>
      </ul>
      <p>
        We also collect basic operational data — the date you signed up,
        when your trial started and ends, the briefs we've composed for you,
        and which links you clicked inside a Monday Brief email.
      </p>

      <h2>2. How we use your information</h2>
      <p>We use your data to:</p>
      <ul>
        <li>Compose your weekly Monday Brief with observations and recommendations.</li>
        <li>Deliver that brief to your email inbox.</li>
        <li>Log the actions you take on each recommendation so we can help you follow up.</li>
        <li>Improve the product based on what customers find useful.</li>
      </ul>
      <p>
        We do not sell your data. We do not share it with third parties for
        their marketing.
      </p>

      <h2>3. How we store your information</h2>
      <p>
        Your account data lives in our production database. Emails are sent
        through Resend, a transactional email provider. We use industry-standard
        practices to keep your data protected in transit and at rest.
      </p>

      <h2>4. Your choices</h2>
      <ul>
        <li>You can pause your Monday Brief at any time from your dashboard or from the pause link in any brief email.</li>
        <li>You can unsubscribe from all Monday Brief emails from the unsubscribe link in any brief.</li>
        <li>You can request a copy of the data we have about your business, or ask us to delete it, by emailing <a href="mailto:briefs@bullsharkbuilds.com">briefs@bullsharkbuilds.com</a>.</li>
      </ul>

      <h2>5. Children's privacy</h2>
      <p>
        Your Monday Brief is intended for business owners and operators. We do
        not knowingly collect information from anyone under 18.
      </p>

      <h2>6. Cookies and tracking</h2>
      <p>
        We use cookies and similar technologies only to keep you signed in and
        to remember the state of pages you've visited. We do not use
        third-party ad-tracking or cross-site trackers.
      </p>

      <h2>7. Changes to this policy</h2>
      <p>
        We may update this policy from time to time. When we do, we'll change
        the "Last updated" date at the top and, for material changes, tell you
        directly through your Monday Brief.
      </p>

      <h2>8. Contact</h2>
      <p>
        Questions? Email <a href="mailto:briefs@bullsharkbuilds.com">briefs@bullsharkbuilds.com</a>.
      </p>
    </LegalPage>
  );
}
